// Moves sensitive auth params out of the URL into memory before analytics (GTM/etc.)
// can read window.location. Path-scoped so we don't strip /oauth_callback's Amplify PKCE ?code=.
const SENSITIVE_PARAMS_BY_PATH: Record<string, string[]> = {
  "/reset-password": ["code", "username"],
  "/login/invite": ["pass", "username"],
  "/jwt-login": ["jwt"],
};

const store = new Map<string, string>();

export function stripSensitiveParams() {
  const keys = SENSITIVE_PARAMS_BY_PATH[window.location.pathname];
  if (!keys) return;

  const params = new URLSearchParams(window.location.search);
  let stripped = false;

  for (const key of keys) {
    const value = params.get(key);
    if (value !== null) {
      store.set(key, value);
      params.delete(key);
      stripped = true;
    }
  }

  if (stripped) {
    const search = params.toString();
    const cleanUrl = window.location.pathname + (search ? `?${search}` : "") + window.location.hash;
    window.history.replaceState(null, "", cleanUrl);
  }
}

export function getSensitiveParam(key: string): string | null {
  return store.get(key) ?? null;
}
